 
if (!customElements.get('deployer-cart-discount')) {
  customElements.define(
    'deployer-cart-discount',
   
    class DeployerCartDiscount extends HTMLElement {
      constructor() {
        super();
        this.applyButton = this.querySelector('.deployer-cart-discount_button');
        this.input = this.querySelector('.deployer-cart-discount_input');
   
        //Connect Listeners
        this.applyButton.addEventListener('click', this.submitDiscount.bind(this));
        this.querySelector('.cart-discount__remove-discount').addEventListener('click', this.removeDiscount.bind(this));
        this.addEventListener('discount:remove', this.removeDiscount.bind(this));
      }
   
      async submitDiscount(event) {
        event.preventDefault();
        this.applyButton.disabled = true;
        if (localStorage.getItem('discountCode') != null) {
          this.removeDiscount();
          return;
        }
        const discountCode = this.input.value;
        if (discountCode === '') {
          this.setErrorMode('Veuillez saisir un code');
        } else {
          this.applyCode(discountCode);
        }
      }
   
      async removeDiscount() {
        console.log('removeDiscount');
        const badge = this.querySelector(".cart-discount_badge");
   
        if (badge.classList.contains("loading")) {
          return;
        }
   
        this.setButtonLoading();
        badge.classList.add("loading");
        localStorage.removeItem("discountCode");
        
        try {
          await this.applyCode("");
        } catch (error) {
          console.error('Erreur lors de la suppression du code de réduction:', error);
        } finally {
          this.updateCart();
          this.setButtonLoaded();
        }
      }
   
      async applyCode(discountCode) {
        // Créer un AbortController pour gérer l'annulation
        const abortController = new AbortController();
        
        try {
          this.setButtonLoading();
          // Récupérer les codes de réduction existants (adaptés au contexte)
          const existingDiscounts = [];
          
          // Vérifier si le code existe déjà
          if (existingDiscounts.includes(discountCode)) {
            this.setErrorMode("Ce code promo est déjà appliqué");
            return;
          }
      
          // Ajouter le nouveau code à la liste existante
          existingDiscounts.push(discountCode);
          
          // Configuration de la requête comme dans le repo
          const config = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ 
              discount: existingDiscounts.join(','),
            }),
            signal: abortController.signal
          };
      
          // Utiliser l'API REST Shopify comme dans le repo
          const response = await fetch(window.Shopify.routes.root + "cart/update.js", config);
          const data = await response.json();
      
          // Vérifier si le code n'est pas applicable
          const failedDiscount = data.discount_codes?.find(discount => 
            discount.code === discountCode && discount.applicable === false
          );
          
          if (failedDiscount) {
            this.setErrorMode("Ce code promo n'est pas applicable");
            return;
          }
      
          // Stocker les informations du code de réduction
          const appliedDiscount = data.discount_codes?.find(
            d => d.code.toUpperCase() === discountCode.toUpperCase()
          );
          
          if (appliedDiscount) {
            const localStorageValue = {
              code: appliedDiscount.code.trim(),
              totalCart: data.total_price || 0,
            };
            localStorage.setItem("discountCode", JSON.stringify(localStorageValue));
          }
          
          this.updateCart();
        } catch (error) {
          // Gérer l'annulation de la requête
          if (error.name === 'AbortError') {
            return;
          }
          
          console.error('Erreur lors de l\'application du code de réduction:', error);
          this.setErrorMode("Une erreur est survenue");
        } finally {
          this.setButtonLoaded();
        }
      }
   
      /**
      * Rafraîchit le panier et les composants associés
      * @param {boolean} isCartPage - Si true, recharge la page si on est sur la page panier
      */
      refreshCart(isCartPage = true) {
        // Deployer Cart Drawer
        document.dispatchEvent(new CustomEvent('deployer-cart-drawer:refresh'));
   
        // Cart Drawer Thème Impact & Prestige
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
          })
        );
   
        // Cart page
        if (isCartPage && window.location.pathname.includes('/cart')) {
          window.location.reload();
        }
      }
   
      setErrorMode(message = 'Veuillez saisir un code valide') {
        // Reset the button state
        this.applyButton.disabled = false;
        this.applyButton.classList.remove('deployer-button--is-loading');
        // Set the input in error mode
        this.input.focus();
        this.input.classList.add('deployer-cart-discount_input-error');
        this.input.placeholder = message;
        this.input.value = '';
        setTimeout(() => {
          this.input.classList.remove('deployer-cart-discount_input-error');
          this.input.placeholder = this.input.dataset.defaultPlaceholder;
        }, 2000);
      }
   
      setButtonLoading() {
        this.applyButton.disabled = true;
        this.applyButton.classList.add('deployer-button--is-loading');
      }
   
      setButtonLoaded() {
        this.applyButton.disabled = false;
        this.applyButton.classList.remove('deployer-button--is-loading');
      }
   
      async updateCart() {
        const discount = localStorage.getItem("discountCode") ? JSON.parse(localStorage.getItem("discountCode")).code : null;
        
        return await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              discount: discount,
            },
            sections: window.deployerAdapter.cartDrawerSection,
            sections_url: window.location.pathname,
          }),
        }).then(() => {
          // Deployer Cart Drawer
          document.dispatchEvent(new CustomEvent('deployer-cart-drawer:refresh'));
   
          // Cart Drawer Thème Impact & Prestige
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
            })
          );
   
          // Cart page
          if (window.location.pathname.includes('/cart')) {
            window.location.reload();
          }
   
          // Generic Cart Drawer Refresh -> Si le thème n'a pas de fonction ou d'évenement pour rafraichir le panier
          const cartDrawerSection = deployerAdapter.cartDrawerSection || 'cart-drawer'; //shopify-section-cart-drawer = cart-drawer
          const cartDrawerWebComponent = deployerAdapter.cartDrawerWebComponent || 'cart-drawer';
          fetch(window.Shopify.routes.root + '?sections=' + cartDrawerSection)
            .then((res) => res.json())
            .then((data) => {
              document.querySelector(cartDrawerWebComponent).innerHTML = new DOMParser().parseFromString(data[cartDrawerSection], 'text/html').querySelector(cartDrawerWebComponent).innerHTML;
            });
        });
      }
    }
  );
}
   